import React, { Suspense, lazy } from 'react';
import { Routes, Route } from 'react-router-dom';
import { CircularProgress, Box } from '@mui/material';
import PrivateAdminRoute from './Components/PrivateAdminRoute';
import Sidenav from './Components/Sidenav';

// Lazy load all route components for code splitting
const HomePage = lazy(() => import('./Pages/HomePage'));
const ShopPage = lazy(() => import('./Pages/ShopPage'));
const ShopDetailsPage = lazy(() => import('./Pages/ShopDetailsPage'));
const Pages = lazy(() => import('./Pages/Pages'));
const ContactPage = lazy(() => import('./Pages/ContactPage'));
const Login = lazy(() => import('./Pages/Login'));
const SignUp = lazy(() => import('./Pages/SignUp'));
const ProductDetailPage = lazy(() => import('./Pages/ProductDetailPage'));
const EmailVerify = lazy(() => import('./Pages/EmailVerify'));
const Numberverify = lazy(() => import('./Pages/Numberverify'));
const CodeVerify = lazy(() => import('./Pages/CodeVerify'));
const Favorites = lazy(() => import('./Pages/Favorites'));
const ManageAdd = lazy(() => import('./Pages/ManageAdd'));
const Profile = lazy(() => import('./Pages/Profile'));
const ForgotPassword = lazy(() => import('./Pages/ForgotPassword'));
const ResetPassword = lazy(() => import('./Pages/ResetPassword'));
const SearchResults = lazy(() => import('./Pages/SearchResults'));
const AboutExchanza = lazy(() => import('./Pages/AboutExchanza'));
const PrivacyPolicy = lazy(() => import('./Pages/PrivacyPolicy'));
const RefundCancellationPolicy = lazy(() => import('./Pages/RefundCancellationPolicy'));
const SafetyTips = lazy(() => import('./Pages/SafetyTips'));
const TermsOfUse = lazy(() => import('./Pages/TermsOfUse'));
const CareerOpportunities = lazy(() => import('./Pages/CareerOpportunities'));
const FAQs = lazy(() => import('./Pages/FAQs'));
const Help = lazy(() => import('./Pages/Help'));
const Settings = lazy(() => import('./Pages/Settings'));
const PublicProfile = lazy(() => import('./Pages/PublicProfile'));
const ChatsPage = lazy(() => import('./Pages/ChatsPage'));

// Loading fallback component
const LoadingFallback = () => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '50vh',
    }}
  >
    <CircularProgress sx={{ color: '#19474C' }} />
  </Box>
);

const AppRoutes = () => {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/product/:id" element={<ProductDetailPage />} />
        <Route path="/shop" element={<ShopPage />} />
        <Route path="/shop-details" element={<ShopDetailsPage />} />
        <Route path="/pages" element={<Pages />} />
        <Route path="/contact" element={<ContactPage/>} />
        <Route path="/login" element={<Login/>} />
        <Route path="/signup" element={<SignUp/>} />
        <Route path="/terms" element={<TermsOfUse/>} />
        <Route path="/emailverify" element={<EmailVerify/>} />
        <Route path="/numberverify" element={<Numberverify/>} />
        <Route path="/codeverify" element={<CodeVerify/>} />
        <Route path="/favorite" element={<Favorites/>} />
        <Route path="/manage-ads" element={<ManageAdd/>} />
        <Route path="/profile" element={<Profile/>} />
        <Route path="/forgot-password" element={<ForgotPassword/>} />
        <Route path="/reset-password/:token" element={<ResetPassword/>} />
        <Route path="/search" element={<SearchResults/>} />
        <Route path="/about" element={<AboutExchanza/>} />
        <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
        <Route path="/refund-cancellation-policy" element={<RefundCancellationPolicy/>} />
        <Route path="/safety-tips" element={<SafetyTips/>} />
        <Route path="/terms-of-use" element={<TermsOfUse/>} />
        <Route path="/careers" element={<CareerOpportunities/>} />
        <Route path="/faqs" element={<FAQs/>} />
        <Route path="/help" element={<Help/>} />
        <Route path="/settings" element={<Settings/>} />
        <Route path="/public-profile" element={<PublicProfile/>} />
        <Route path="/profile/:userId" element={<PublicProfile/>} />
        <Route path="/chats" element={<ChatsPage/>} />
        <Route 
          path="/admin/*" 
          element={
            <PrivateAdminRoute>
              <Sidenav />
            </PrivateAdminRoute>
          } 
        />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
